import { type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { formatFileSize } from '../../utils';
import { DownloadExamResultFileButton } from '../download-exam-result-file-button';

export interface ExamResultFileListItem {
  id: string;
  fileName: string;
  createdAt: Date;
  fileSize: number;
}

export const columns: GridColDef<ExamResultFileListItem>[] = [
  {
    field: 'fileName',
    headerName: 'File Name',
    sortable: false,
    flex: 1,
  },
  {
    field: 'createdAt',
    headerName: 'Create Date',
    sortable: true,
    width: 200,
    valueFormatter: (params) => formatDateTime(params.value),
  },
  {
    field: 'fileSize',
    headerName: 'File Size',
    sortable: false,
    width: 120,
    valueFormatter: (params) => formatFileSize(params.value),
  },
  {
    field: 'download',
    headerName: 'Action',
    sortable: false,
    width: 120,
    renderCell: (params) => {
      return <DownloadExamResultFileButton id={params.row.id} />;
    },
  },
];
